// TODO: is encode url really needed?
// TODO: refactor, this is temp implementation for POC
export const buildUrl = (
    host: string,
    params?: Record<string, string | number | boolean | null | undefined>
): string => {
    const pairs: string[] = [];
    if (params) {
        for (const key in params) {
            const value = params[key];
            if (typeof value === 'object' && value !== null) {
                continue; // Skip object values
            }
            pairs.push(`${key}=${value}`);
        }
    }
    return `${host}?${pairs.join('&')}`;
};

export const buildApiUrl = (config: Record<string, any>) => `${config.protocol}://${config.host}${config.pathPrefix}`;
